import { configureStore } from '@reduxjs/toolkit';
import { throttle } from 'lodash';
import loginDetailsSlice from '../connectedComponent/loginDetails/loginDetails.slice';
import selectLocationsSlice from '../connectedComponent/selectedLocations/selectedLocations.slice';
import selectDMSSlice from '../connectedComponent/selectedDMS/selectedDMS.slice';
import privacyProtectionSlice from '../connectedComponent/privacyProtection/privacyProtection.slice';
import dealerApiPreferencesSlice from '../connectedComponent/dealerApiPreferences/dealerApiPreferences.slice';
import apiFieldsSlice from '../connectedComponent/apiFields/apiFields.slice';
import solutionInfoSlice from '../connectedComponent/solutionInfo/solutionInfo.slice';
import appTermsSlice from '../connectedComponent/appTerms/appTerms.slice';
import subscriptionManagementSlice from '../connectedComponent/subscriptionManagement/subscriptionManagement.slice';
import updateFortellisTermsSlice from '../connectedComponent/updateFortellisTerms/updateFortellisTerms.slice';
import apiTermsSlice from '../connectedComponent/apiTerms/apiTerms.slice';
import paymentCheckoutSlice from '../connectedComponent/paymentCheckout/paymentCheckout.slice';
import reviewSubscriptionSlice from '../connectedComponent/reviewSubscription/reviewSubscription.slice';
import completeSubscriptionSlice from '../connectedComponent/completeSubscription/completeSubscription.slice';
import verifyAccountSlice from '../connectedComponent/verifyAccount/verifyAccount.slice';
import updateDMSAccountsSlice from '../connectedComponent/updateDMSAccounts/updateDMSAccounts.slice';
import addLocationsSlice from '../connectedComponent/addLocations/addLocations.slice';
import uiFactorySlice from '../connectedComponent/uiFactory/uiFactory.slice';
import apiIntegrationSlice  from '../connectedComponent/apiIntegrations/apiIntegration.slice';
import removeLocationsSlice from '../connectedComponent/removeLocations/removeLocations.slice';
import cancelSubscriptionSlice from '../connectedComponent/subscriptionManagement/cancelSubscription.slice';
import manageBulkConnectionsSlice from '../connectedComponent/manageBulkConnections/manageBulkConnectioins.slice';
import paymentSettingsSlice from '../connectedComponent/paymentCheckout/paymentSettings.slice';
import dealerPurchaseHistorySlice from '../connectedComponent/dealerPurchaseHistory/dealerPurchaseHistory.slice';
import dealerRefundHistorySlice from '../connectedComponent/dealerRefundHistory/dealerRefundHistory.slice';
import multiDepositSlice from '../connectedComponent/verifyAccount/multiDeposit.slice';
import consentDetailsSlice from '../connectedComponent/consentDetails/consentDetails.slice';
import dataRightsSlice from '../connectedComponent/dataRights/dataRights.slice';
import provisionSettings from '../connectedComponent/provisionSettings/provisionSettings.slice';
import dataTransactionSlice from '../connectedComponent/dataTransaction/dataTransaction.slice';
import dealerIntegrationsReportSlice from '../connectedComponent/dealerIntegrationReport/dealerIntegrationReport.slice';
import ManageIntegrationsV2Slice from '../connectedComponent/ManageIntegrationsV2/ManageIntegrationsV2.slice';
import orderAPISlice from '../connectedComponent/orderAPI/orderAPI.slice';
import ConfigurationsSlice from '../connectedComponent/configurations/Configurations.slice';
import apiDirectorySlice from '../connectedComponent/apiDirectory/apiDirectory.slice';
import daabSubscriptionsSlice from '../connectedComponent/daabSubscriptions/daabSubscriptions.slice'

const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState !== null) {
      return JSON.parse(serializedState);
    }
    return {};
  } catch (e) {
    return {};
  }
};
const saveToLocalStorage = (state) => {
  if (!state.loginDetailsSlice.loggingOut) {
    try {
      let loginDetailsState = {};
      loginDetailsState.loginDetailsSlice = state.loginDetailsSlice;
      const serializedState = JSON.stringify(loginDetailsState);
      localStorage.setItem('state', serializedState);
    } catch (e) {
      return {};
    }
  }
};
const store = configureStore({
  reducer: {
    loginDetailsSlice,
    selectLocationsSlice,
    selectDMSSlice,
    privacyProtectionSlice,
    dealerApiPreferencesSlice,
    apiFieldsSlice,
    solutionInfoSlice,
    appTermsSlice,
    subscriptionManagementSlice,
    updateFortellisTermsSlice,
    apiTermsSlice,
    paymentCheckoutSlice,
    reviewSubscriptionSlice,
    completeSubscriptionSlice,
    verifyAccountSlice,
    updateDMSAccountsSlice,
    addLocationsSlice,
    uiFactorySlice,
    apiIntegrationSlice,
    removeLocationsSlice,
    cancelSubscriptionSlice,
    manageBulkConnectionsSlice,
    paymentSettingsSlice,
    dealerPurchaseHistorySlice,
    multiDepositSlice,
    consentDetailsSlice,
    dataRightsSlice,
    dealerRefundHistorySlice,
    provisionSettings,
    dataTransactionSlice,
    dealerIntegrationsReportSlice,
    ManageIntegrationsV2Slice,
    orderAPISlice,
    ConfigurationsSlice,
    apiDirectorySlice,
    daabSubscriptionsSlice
  },
  preloadedState: loadFromLocalStorage()
});

store.subscribe(
  throttle(() => {
    saveToLocalStorage(store.getState());
  }, 5000)
);

export default store;